// Third party libs/components
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

//Style
import * as Styled from './DlocalInput.styles';

const DlocalInput = ({
  name,
  inputRef,
  input,
  children,
  onChange,
  ...restProp
}) => {
  useEffect(() => {
    if (input) {
      input.on('change', evt => {
        onChange({
          ...evt,
          target: {
            name,
          },
        });
      });
    }
  }, [input]);

  return (
    <Styled.Label {...restProp}>
      {children}
      <Styled.InputWrapper ref={inputRef}></Styled.InputWrapper>
    </Styled.Label>
  );
};

DlocalInput.propTypes = {
  onChange: PropTypes.func,
};

DlocalInput.defaultProps = {
  onChange: () => {},
};

export default DlocalInput;
